export const RECONCILIATION_PERMISSION_RESOURCE = 'vault:reconciliation';

export const RECONCILIATION_NS = 'module.vaultReconciliation';

/** The queue's tabs. Later flows (UNRESOLVED work orders, ESCALATED close-outs: XBIT-4870) add theirs here. */
export const RECONCILIATION_TABS = ['frozen'] as const;
export type ReconciliationTab = (typeof RECONCILIATION_TABS)[number];

/** The BFF's bounds (`ProposeShareAdjustmentDto` / `ResolveReconciliationBreakDto`). */
export const TEXT_MAX = 500;
export const REASON_CODE_PATTERN = /^[A-Z][A-Z0-9_]{0,63}$/;
export const DEFAULT_REASON_CODE = 'RECON_BREAK';
export const HOLDER_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
/** A signed decimal string, at most 6 dp: the engine's Fixed6. */
export const DELTA_PATTERN = /^-?\d+(\.\d{1,6})?$/;

/** How often the run request is read while it is QUEUED / RUNNING / DEFERRED, and for how long. */
export const RUN_POLL_INTERVAL_MS = 3_000;
export const RUN_POLL_LIMIT_MS = 10 * 60_000;

export const PROPOSAL_COLUMNS = [
  'status',
  'holder',
  'delta',
  'reason',
  'break',
  'proposedBy',
  'proposedAt',
  'actions',
] as const;
export const RESOLUTION_COLUMNS = [
  'break',
  'cause',
  'evidence',
  'approvers',
  'adjustment',
  'resolvedAt',
] as const;
/** An RFC 3339 instant, as the BFF's first line of validation takes it. */
export const RFC3339_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
